/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';

export const bookmarkStatusSchema = z.object({
  challengeId: z.number(),
  saved: z.boolean(),
});

export interface IBookmarkStatus {
  challengeId: number;
  saved: boolean;
}

const bookmarkStatusBatchDataSchema = z.object({
  statuses: z.array(bookmarkStatusSchema),
});

export interface IBookmarkStatusBatchData {
  statuses: IBookmarkStatus[];
}

export const getBookmarkStatusBatchV1ResponseSchema = createApiResponseSchema(
  bookmarkStatusBatchDataSchema,
) as z.ZodSchema<IAPI<IBookmarkStatusBatchData>>;

export type IGetBookmarkStatusBatchV1Response = IAPI<IBookmarkStatusBatchData>;
